
export enum DeviceCategoryEnum {
    WEIGH_MACHINE = 'WEIGH_MACHINE',
    TEMPERATURE = 'TEMPERATURE',
    BULB = 'BULB'
}